"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NULL_ACCOUNT = exports.DEFAULT_TIMEOUT = void 0;
var _stellarBase = require("@stellar/stellar-base");
var DEFAULT_TIMEOUT = exports.DEFAULT_TIMEOUT = 5 * 60;
var NULL_ACCOUNT = exports.NULL_ACCOUNT = "GAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAWHF";